export type KonzultaCredentials = {
  username?: string | null;
  password?: string | null;
};
